// src/components/desk/ReasonChips.jsx — the WHY list under a status, extracted VERBATIM from
// MeetingModal.jsx on 2026-09-06 so the meeting card's outcome pill can ask the same question
// with the same rows. One list, two doors; the vocabulary stays server rows (meeting_reason).
import { tOr } from '../../lib/i18n.js'
import { Icon } from '../Icon.jsx'

// WHY, as a chip row (0427). The vocabulary is ROWS from meeting_reason — which
// statuses a reason explains, and whose move it says it is, are data on the row,
// never conditionals here. Required for failed/cancelled (final states close a
// chapter; one tap is the price), optional for pending/rescheduled (living states
// must not slow down — the medium nudge sweeps up what's missed). Same one-tap
// law as the contact-touch outcomes: if reporting costs more than a tap it stops
// happening.
// ⚠️ A LIST OF LINES, NOT PILLS (owner ruling 2026-08-06, from the live screen). Pills are
// for a handful of short values read as a row; a reason list is 6–7 full sentences, and as
// pills they wrap into a ragged block nobody scans — and each tap target is only as big as
// its words. Lines read top-to-bottom like the question they answer, and the whole row is
// tappable, which is what a phone needs. The selected one is marked by a ✓ and colour, not
// by a border: the list must stay a list.
export function ReasonChips({ vocab, status, value, onPick }) {
  const list = (vocab?.reasons || []).filter(r => (r.applies_to_status || []).includes(status))
  if (!list.length) return null
  return (
    <div className="flex flex-col -mx-1">
      {list.map(r => (
        <button key={r.code} onClick={() => onPick(value === r.code ? null : r.code)}
          className={`flex items-center gap-2 text-left text-sm px-1.5 py-1.5 rounded hover:bg-accent ${
            value === r.code ? 'text-primary font-medium' : 'text-foreground'}`}>
          <span className={`shrink-0 w-3 ${value === r.code ? 'text-primary' : 'text-transparent'}`}>
            <Icon name="check" size={13} />
          </span>
          {/* ⚠️ tOr, NOT t — and this is not cosmetic, it is what makes "vocabulary is ROWS,
              not constants" TRUE. `t()` returns the key itself when a string is missing, so
              the moment someone did what this whole design invites — INSERT a reason row —
              the chip would have read `desk_meeting_reason_notary_delay` at the agent. The
              same trap already cost every closed-deal badge in July (see tOr's own comment).
              Every server-driven code on these surfaces now falls back to the code, so a new
              row is ugly until it is translated instead of broken. */}
          <span className="min-w-0">{tOr(`desk_meeting_reason_${r.code}`, r.code)}</span>
        </button>
      ))}
    </div>
  )
}
// status-subset: the two final states that must say WHY (owner ruling 2026-08-05) — everything
// else may. Not MEETING_FINISHED: `closed` is the third finished state and needs no reason,
// because the outcome IS the reason.
export const REASON_REQUIRED = new Set(['failed', 'cancelled'])
